export default function () {
  return {
    errors: {},
    success: false,
    error: false,
    croppingImage: null,
    showCropper: false,
    croppingModel: null,
    datePickerConfig: {
      nextMonthCaption: 'Próximo mês',
      prevMonthCaption: 'Mês anterior',
      setTimeCaption: 'Hora',
      weekdays: [
        'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
      ],
      months: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]
    },
    holiday: {
      picture: '',
      name: '',
      start: null,
      end: null,
      safe_name: '',
      slug: ''
    }
  }
}
